/**
 * Mirrors the backend's AnnouncementPlaceholders so the preview shows exactly what
 * the send will produce. Unknown placeholders are left as typed — a typo should be
 * visible in the preview rather than silently blanked.
 */
export const ANNOUNCEMENT_PLACEHOLDERS = {
  firstName: "{{firstName}}",
  organization: "{{organization}}",
} as const;

export const applyAnnouncementPlaceholders = (
  text: string,
  firstName: string,
  organizationName: string
): string => {
  if (!text) {
    return text;
  }

  return text
    .replace(/\{\{firstName\}\}/gi, firstName)
    .replace(/\{\{organization\}\}/gi, organizationName);
};
